module.exports = __webpack_public_path__ + "img/footerjw.cfe0c01f.png";